// // ============================================================================
// // RSPM Bridge Validation Campaign Mock State
// // ============================================================================
// // Tracks in-progress campaigns between polling requests to simulate
// // asynchronous validation workflow. Keyed by campaignId.

// interface RspmCampaignState {
//   failedMembers: Array<{ eid?: string; iccid: string; msisdn?: string }>;
//   members: Array<{ eid?: string; iccid: string }>;
//   pollingCount: number;
//   scenario: 'all_failed' | 'all_success' | 'error' | 'long_running' | 'partial_success';
//   totalMembers: number;
// }

// const rspmCampaignStates = new Map<string, RspmCampaignState>();

// /**
//  * Scenario configurations for RSPM Bridge validation campaigns.
//  * Each scenario simulates a different user outcome for testing.
//  */
// enum RspmScenario {
//   // All members failed validation
//   ALL_FAILED = 'all_failed',
//   // All members validated successfully
//   ALL_SUCCESS = 'all_success',
//   // Campaign execution error
//   ERROR = 'error',
//   // Long-running: requires 4-5 polling cycles before completion
//   LONG_RUNNING = 'long_running',
//   // Partial success: 3 valid, 2 failed (default - tests most common flow)
//   PARTIAL_SUCCESS = 'partial_success',
// }

// // Select the active scenario here (change to test different flows)
// // Use 'as const' to allow type narrowing in conditionals
// const ACTIVE_SCENARIO = RspmScenario.PARTIAL_SUCCESS as RspmScenario;

// /**
//  * Generates a mock campaign ID.
//  */
// function generateCampaignId(): string {
//   return `rspm-campaign-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
// }

// function getMockEid(member: { eid?: string; iccid: string }, index: number): string {
//   const provided = member.eid?.trim();
//   if (provided) {
//     return provided;
//   }
//   const numericSeed = `${member.iccid}${index}`.replace(/\D/g, '');
//   return `89${numericSeed.padStart(30, '0').slice(-30)}`;
// }

// /**
//  * Initializes campaign state based on the active scenario.
//  */
// function initializeCampaignState(campaignId: string, members: Array<{ eid?: string; iccid: string }>): RspmCampaignState {
//   const normalizedMembers = members.map((member, index) => ({ ...member, eid: getMockEid(member, index) }));
//   const totalMembers = normalizedMembers.length;
//   const state: RspmCampaignState = {
//     failedMembers: [],
//     members: normalizedMembers,
//     pollingCount: 0,
//     scenario: ACTIVE_SCENARIO,
//     totalMembers,
//   };

//   // Configure scenario-specific failed members using actual ICCID values
//   switch (ACTIVE_SCENARIO) {
//     case RspmScenario.PARTIAL_SUCCESS:
//       state.failedMembers = normalizedMembers.slice(0, 2).map((m, i) => ({
//         eid: m.eid,
//         iccid: m.iccid,
//         msisdn: `49${String(i).padStart(9, '0')}`,
//       }));
//       break;
//     case RspmScenario.ALL_SUCCESS:
//       state.failedMembers = [];
//       break;
//     case RspmScenario.ALL_FAILED:
//       state.failedMembers = normalizedMembers.map((m, i) => ({
//         eid: m.eid,
//         iccid: m.iccid,
//         msisdn: `49${String(i).padStart(9, '0')}`,
//       }));
//       break;
//     case RspmScenario.ERROR:
//       state.failedMembers = normalizedMembers.map((m, i) => ({
//         eid: m.eid,
//         iccid: m.iccid,
//         msisdn: `49${String(i).padStart(9, '0')}`,
//       }));
//       break;
//     case RspmScenario.LONG_RUNNING:
//       state.failedMembers = normalizedMembers.slice(0, 1).map((m, i) => ({
//         eid: m.eid,
//         iccid: m.iccid,
//         msisdn: `49${String(i).padStart(9, '0')}`,
//       }));
//       break;
//   }

//   rspmCampaignStates.set(campaignId, state);
//   return state;
// }

// /**
//  * Computes the campaign status based on current polling count and scenario.
//  */
// function getCampaignStatus(state: RspmCampaignState): string {
//   if (state.scenario === RspmScenario.ERROR && state.pollingCount >= 1) {
//     return 'VALIDATE_FAILED';
//   }

//   if (state.scenario === RspmScenario.LONG_RUNNING) {
//     if (state.pollingCount < 3) {
//       return state.pollingCount === 0 ? 'NEW' : 'VALIDATING';
//     }
//     return 'COMPLETE';
//   }

//   if (state.pollingCount < 2) {
//     return state.pollingCount === 0 ? 'NEW' : 'VALIDATING';
//   }

//   return 'COMPLETE';
// }

// /**
//  * Computes campaign progress metrics based on current state.
//  */
// function getCampaignMetrics(state: RspmCampaignState, status: string) {
//   const failedCount = state.failedMembers.length;
//   const completedCount = state.totalMembers - failedCount;

//   if (status === 'VALIDATE_FAILED') {
//     return {
//       completedMembers: 0,
//       failedCreateMembers: 0,
//       failedMembers: failedCount,
//       inProgressMembers: 0,
//       newMemberEntities: 0,
//     };
//   }

//   if (status === 'COMPLETE') {
//     return {
//       completedMembers: completedCount,
//       failedCreateMembers: 0,
//       failedMembers: failedCount,
//       inProgressMembers: 0,
//       newMemberEntities: 0,
//     };
//   }

//   // In-progress statuses: progressively report more members as processed
//   const processedPercentage = Math.min(1, state.pollingCount * 0.5); // 50% per poll
//   const reportedCompleted = Math.floor(completedCount * processedPercentage);
//   const reportedFailed = Math.floor(failedCount * processedPercentage);
//   const reportedInProgress = state.totalMembers - reportedCompleted - reportedFailed;

//   return {
//     completedMembers: reportedCompleted,
//     failedCreateMembers: 0,
//     failedMembers: reportedFailed,
//     inProgressMembers: reportedInProgress,
//     newMemberEntities: 0,
//   };
// }

export const MockData: { [key: string]: Mock } = {
  /**
   * Mock: Simulate a timeout error while loading IoT Suite credentials
   * ("keys") from RSPM Bridge (task-selection step,
   * `app_rspmbridge.find_iotsuite_credential`).
   * Comment out this entry to go back to the default behavior (falls through
   * to `next.handle(request)`).
   */
  'app_rspmbridge.find_iotsuite_credential': {
    response: () => ({
      cmd: {
        errorCodes: [-90103],
        errorMessages: ['NATS reply was empty'],
        success: false,
      },
    }),
  },
  // /**
  //  * Mock: Create RSPM validation campaign.
  //  * Initializes a new campaign in NEW state and prepares polling state.
  //  */
  // 'app_rspmbridge.create_campaign': {
  //   response: (params: any) => {
  //     const campaignId = generateCampaignId();
  //     const members = params.members || [];
  //     const state = initializeCampaignState(campaignId, members);
  //     if (ACTIVE_SCENARIO === RspmScenario.ERROR) {
  //       return {
  //         cmd: {
  //           errorMessages: ['Failed to create campaign: validation service unavailable'],
  //           success: false,
  //         },
  //       };
  //     }
  //     return {
  //       cmd: {
  //         params: {
  //           campaignId,
  //           campaignStatus: 'NEW',
  //           ...getCampaignMetrics(state, 'NEW'),
  //         },
  //         success: true,
  //       },
  //     };
  //   },
  // },
  // /**
  //  * Mock: Get failed members for RSPM validation campaign.
  //  * Returns details of members that failed validation.
  //  * Includes ICCID, EID, MSISDN, error message, and metadata.
  //  */
  // 'app_rspmbridge.get_campaign_failed_members': {
  //   response: (params: any) => {
  //     const campaignId = params.campaignId;
  //     const state = rspmCampaignStates.get(campaignId);
  //     if (!state) {
  //       return {
  //         cmd: {
  //           errorMessages: ['Campaign not found'],
  //           params: {
  //             failedMembers: [],
  //           },
  //           success: false,
  //         },
  //       };
  //     }
  //     Generate failed member details using stored members
  //     const failedMembers = state.failedMembers.map((failed, index) => ({
  //       apnId: 'iot.vodafone.com',
  //       eid: failed.eid,
  //       errorMessage: index === 0 ? 'eid not found' : 'iccid not found',
  //       executionCompletedAt: new Date().toISOString(),
  //       failedMemberUpdatedAt: new Date().toISOString(),
  //       iccid: failed.iccid,
  //       msisdn: failed.msisdn || `49${String(index).padStart(9, '0')}`,
  //       projectName: 'Unassign SGP22',
  //     }));
  //     return {
  //       cmd: {
  //         params: {
  //           failedMembers,
  //         },
  //         success: true,
  //       },
  //     };
  //   },
  // },
  // /**
  //  * Mock: Get RSPM validation campaign status (polling).
  //  * Simulates campaign progression through multiple polling cycles.
  //  * Transitions from NEW → VALIDATING → COMPLETE based on polling count.
  //  * State is maintained between calls via rspmCampaignStates map.
  //  */
  // 'app_rspmbridge.get_campaign_status': {
  //   response: (params: any) => {
  //     const campaignId = params.campaignId;
  //     const state = rspmCampaignStates.get(campaignId);
  //     if (!state) {
  //       return {
  //         cmd: {
  //           errorMessages: ['Campaign not found'],
  //           success: false,
  //         },
  //       };
  //     }
  //     state.pollingCount++;
  //     const status = getCampaignStatus(state);
  //     const metrics = getCampaignMetrics(state, status);
  //     if (status === 'VALIDATE_FAILED') {
  //       return {
  //         cmd: {
  //           params: {
  //             campaignId,
  //             campaignStatus: status,
  //             ...metrics,
  //             errorMessage: 'Validation failed: service error occurred',
  //           },
  //           success: true,
  //         },
  //       };
  //     }
  //     return {
  //       cmd: {
  //         params: {
  //           campaignId,
  //           campaignStatus: status,
  //           ...metrics,
  //         },
  //         success: true,
  //       },
  //     };
  //   },
  // },
  // ========================================================================
  // Additional Mock Scenarios (commented for easy switching during dev)
  // ========================================================================
  /* Scenario: All members successfully validated (UNCOMMENT TO TEST)
  'app_rspmbridge.create_campaign': {
    response: (params: any) => {
      const campaignId = generateCampaignId();
      const members = params.members || [];
      initializeCampaignState(campaignId, members.length);
      return {
        cmd: {
          success: true,
          params: {
            campaignId,
            campaignStatus: 'NEW',
            completedMembers: 0,
            failedCreateMembers: 0,
            failedMembers: 0,
            inProgressMembers: members.length,
            newMemberEntities: members.length,
          },
        },
      };
    },
  },
  'app_rspmbridge.get_campaign_status': {
    response: (params: any) => {
      const campaignId = params.campaignId;
      let state = rspmCampaignStates.get(campaignId);
      if (!state) {
        return {
          cmd: {
            success: false,
            errorMessages: ['Campaign not found'],
          },
        };
      }
      state.pollingCount++;
      const status = state.pollingCount < 2 ? (state.pollingCount === 0 ? 'NEW' : 'VALIDATING') : 'COMPLETE';
      return {
        cmd: {
          success: true,
          params: {
            campaignId,
            campaignStatus: status,
            completedMembers: state.totalMembers,
            failedCreateMembers: 0,
            failedMembers: 0,
            inProgressMembers: 0,
            newMemberEntities: 0,
          },
        },
      };
    },
  },
  'app_rspmbridge.get_campaign_failed_members': {
    response: (params: any) => ({
      cmd: {
        success: true,
        params: { failedMembers: [] },
      },
    }),
  },
  */
};

export const MockedEndpoint = {
  // example mock endpoint
  // "https://toes-engr.devicewise.net/private/campaigns/upload" : (...args) => {
  //     console.log('ex')
  //     return { status: 'ERROR', errorMessage: 'PERMISSION DENY'}},
};

interface Mock {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: (...args: any[]) => unknown;
}
